var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "audit-dialog",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.closeDialog.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c("div", { staticClass: "product-section" }, [
              _c("h3", { staticClass: "section-title" }, [
                _vm._v("询盘商品信息"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "product-header" }, [
                _c("img", {
                  staticClass: "product-image",
                  attrs: {
                    src: _vm.$baseUrl + _vm.product.image,
                    alt: "商品图片",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "product-info" }, [
                  _c("div", { staticClass: "product-name" }, [
                    _vm._v(_vm._s(_vm.product.commodityName)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "product-category" }, [
                    _vm._v(_vm._s(_vm.product.categoryName)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "product-details" }, [
                _c("div", { staticClass: "detail-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("规格：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.product.specifications))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("购买数量：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.product.quantity))]),
                  _vm._v(" "),
                  _c("span", { staticClass: "label price-label" }, [
                    _vm._v("现价："),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.product.presentPrice))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-row" }, [
                  _c("span", { staticClass: "label" }, [
                    _vm._v("消费者收件邮箱："),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.product.email))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("备注：")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "remark" }, [
                    _vm._v(_vm._s(_vm.product.message)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("审核状态：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.product.status == 0
                          ? "审核中"
                          : _vm.product.status == 1
                          ? "通过"
                          : "未通过"
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "confirm-section" },
              [
                _c("h3", { staticClass: "section-title" }, [
                  _vm._v("确认信息"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("审核状态：")]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "请选择状态" },
                        on: { change: _vm.handleStatusChange },
                        model: {
                          value: _vm.form.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "status", $$v)
                          },
                          expression: "form.status",
                        },
                      },
                      _vm._l(_vm.exmineStatus, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.form.status === 1
                  ? [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("商品名称：")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.commodityName,
                              expression: "form.commodityName",
                            },
                          ],
                          staticClass: "form-input",
                          attrs: { type: "textarea" },
                          domProps: { value: _vm.form.commodityName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form,
                                "commodityName",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("商品规格：")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.specifications,
                              expression: "form.specifications",
                            },
                          ],
                          staticClass: "form-input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.form.specifications },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form,
                                "specifications",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("价格：")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.unitPrice,
                              expression: "form.unitPrice",
                            },
                          ],
                          staticClass: "form-input",
                          attrs: { type: "number" },
                          domProps: { value: _vm.form.unitPrice },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form,
                                "unitPrice",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("购买数量：")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.quantity,
                              expression: "form.quantity",
                            },
                          ],
                          staticClass: "form-input",
                          attrs: { type: "number" },
                          domProps: { value: _vm.form.quantity },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form,
                                "quantity",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("总价：")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.totalPrice,
                              expression: "form.totalPrice",
                            },
                          ],
                          staticClass: "form-input",
                          attrs: { type: "number" },
                          domProps: { value: _vm.form.totalPrice },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form,
                                "totalPrice",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("收件人邮箱：")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.toUser,
                              expression: "form.toUser",
                            },
                          ],
                          staticClass: "form-input",
                          attrs: { type: "email" },
                          domProps: { value: _vm.form.toUser },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.form, "toUser", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("回件商家邮箱：")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.businessEmail,
                              expression: "form.businessEmail",
                            },
                          ],
                          staticClass: "form-input",
                          attrs: { type: "email" },
                          domProps: { value: _vm.form.businessEmail },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.form,
                                "businessEmail",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "payment-section" }, [
                        _c("h3", { staticClass: "section-title" }, [
                          _vm._v("收款信息"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "payment-methods" }, [
                          _c(
                            "button",
                            {
                              staticClass: "method-btn",
                              class: { active: _vm.form.collectionType === 1 },
                              on: {
                                click: function ($event) {
                                  _vm.form.collectionType = 1
                                },
                              },
                            },
                            [_vm._v("\n              收款码\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "method-btn",
                              class: { active: _vm.form.collectionType === 2 },
                              on: {
                                click: function ($event) {
                                  _vm.form.collectionType = 2
                                },
                              },
                            },
                            [_vm._v("\n              银行卡\n            ")]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.form.collectionType === 1
                          ? _c("div", { staticClass: "qrcode-section" }, [
                              _c(
                                "div",
                                { staticClass: "upload-area" },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      class: {
                                        "hide-upload": _vm.fileList.length >= 1,
                                      },
                                      attrs: {
                                        action: _vm.$baseUrl + "/other/upload",
                                        "before-upload": _vm.handleBeforeUpload,
                                        "list-type": "picture-card",
                                        "on-preview":
                                          _vm.handlePictureCardPreview,
                                        "on-remove": _vm.handleRemove,
                                        "on-exceed": _vm.hadleExceed,
                                        "on-success": _vm.handelSuccess,
                                        limit: 1,
                                        name: "file",
                                        "file-list": _vm.fileList,
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-plus" })]
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _c("div", { staticClass: "bank-section" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("受益人姓名：")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.beneficiaryName,
                                      expression: "form.beneficiaryName",
                                    },
                                  ],
                                  staticClass: "form-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "请输入受益人姓名",
                                  },
                                  domProps: { value: _vm.form.beneficiaryName },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.form,
                                        "beneficiaryName",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("受益人地址：")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.beneficiaryAddress,
                                      expression: "form.beneficiaryAddress",
                                    },
                                  ],
                                  staticClass: "form-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "请输入受益人地址",
                                  },
                                  domProps: {
                                    value: _vm.form.beneficiaryAddress,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.form,
                                        "beneficiaryAddress",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("受益人账号：")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.beneficiaryAccNo,
                                      expression: "form.beneficiaryAccNo",
                                    },
                                  ],
                                  staticClass: "form-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "请输入受益人账号",
                                  },
                                  domProps: {
                                    value: _vm.form.beneficiaryAccNo,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.form,
                                        "beneficiaryAccNo",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("银行地址：")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.addressOfBank,
                                      expression: "form.addressOfBank",
                                    },
                                  ],
                                  staticClass: "form-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "请输入银行地址",
                                  },
                                  domProps: { value: _vm.form.addressOfBank },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.form,
                                        "addressOfBank",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("SWIFT码：")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.swiftCode,
                                      expression: "form.swiftCode",
                                    },
                                  ],
                                  staticClass: "form-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "请输入SWIFT码",
                                  },
                                  domProps: { value: _vm.form.swiftCode },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.form,
                                        "swiftCode",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("邮政编码：")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.postCode,
                                      expression: "form.postCode",
                                    },
                                  ],
                                  staticClass: "form-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "请输入邮政编码",
                                  },
                                  domProps: { value: _vm.form.postCode },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.form,
                                        "postCode",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("受益人银行：")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.beneficiaryBank,
                                      expression: "form.beneficiaryBank",
                                    },
                                  ],
                                  staticClass: "form-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "请输入受益人银行",
                                  },
                                  domProps: { value: _vm.form.beneficiaryBank },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.form,
                                        "beneficiaryBank",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("电话：")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.tel,
                                      expression: "form.tel",
                                    },
                                  ],
                                  staticClass: "form-input",
                                  attrs: {
                                    type: "tel",
                                    placeholder: "请输入电话",
                                  },
                                  domProps: { value: _vm.form.tel },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.form,
                                        "tel",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c("label", [_vm._v("自定义字段：")]),
                                  _vm._v(" "),
                                  _c("Editor", {
                                    staticStyle: {
                                      height: "500px",
                                      "overflow-y": "hidden",
                                    },
                                    attrs: {
                                      defaultConfig: _vm.editorConfig,
                                      mode: _vm.mode,
                                    },
                                    on: { onCreated: _vm.onCreated },
                                    model: {
                                      value: _vm.form.customDefinition,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "customDefinition",
                                          $$v
                                        )
                                      },
                                      expression: "form.customDefinition",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "action-buttons" }, [
              _c(
                "button",
                { staticClass: "cancel-btn", on: { click: _vm.closeDialog } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "confirm-btn", on: { click: _vm.confirmAudit } },
                [_vm._v("确认审核")]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }